export enum TermBaseEntry {
  TERM,
  BASE,
  BOTH,
}

export namespace TermBaseEntry {
  let elements = [TermBaseEntry.TERM, TermBaseEntry.BASE, TermBaseEntry.BOTH];
  let alias = "com.bcdfx.model.common.api.enums.TermBaseEntry";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
